import React from 'react'
import PropTypes from 'prop-types'
import { Container, Columns, Column } from '@resurs/midas-react'
import { Tabs } from '../../../../midasComponents'
import DebitPayment from './DebitPayment'
import CreditLimit from './CreditLimit'
import PaymentMethodHeader from './PaymentMethodHeader'
import PaymentMethodDescription from './PaymentMethodDescription'
import PaymentPerMonth from '../shared/PaymentPerMonth'
import { getText } from '../../../../internal/TextLabels'
import BonusChecks from '../shared/BonusChecks/BonusChecks'
import { renderBonusLabel } from '../shared/BonusChecks/UIHelpers'
import { isRevolvingCredit } from '../../../../models/payment-methods'
import CreditInfo from '../../../../components/OneProduct/CreditInfo'
import CreditSlider from '../../../../components/OneProduct/CreditSlider'
import CreditPlan from '../../../../components/OneProduct/CreditPlan'
import SendMailModalForm from '../../../../components/SendMailModalForm'
import { format } from '../../../../models/format'

class NewCardOrAccount extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      creditValid: false,
      debitValid: false,
      creditCost: {},
      showMailModal: false,
      mail: '',
    }
  }

  static getDerivedStateFromProps(newProps) {
    if (!newProps.debitPaymentChecked) {
      return { debitValid: true }
    }
    if (newProps.debitPaymentChecked) {
      return { debitValid: false }
    }
    return null
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.debitValid !== this.state.debitValid) {
      if (this.state.creditValid && !this.props.debitPaymentChecked) {
        this.props.isValid(this.state.creditValid)
      } else if (this.state.creditValid && this.props.debitPaymentChecked) {
        this.props.isValid(this.state.creditValid && this.state.debitValid)
      }
    }
  }

  valid(validation) {
    if (!this.props.debitPaymentChecked) {
      this.setState({ debitValid: true })
    }
    if (validation.key === 'limit') {
      this.setState({ creditValid: validation.valid }, () => {
        if (validation.valid && this.state.debitValid) {
          this.props.isValid(true)
        }
      })
    }
    if (validation.key === 'debit-amount') {
      this.setState({ debitValid: validation.valid }, () => {
        if (this.state.creditValid && validation.valid) {
          this.props.isValid(true)
        }
      })
    }
    this.props.isValid(false)
  }

  render() {
    const {
      selectedPaymentMethod,
      limit,
      newPageLoading,
      onChangeLimit,
      onDebitPaymentSwitch,
      debitPaymentChecked,
      onChangeAmount,
      debitReference,
      onChangeDebitReference,
      customerType,
      debitDisabled,
      paymentMethodsExist,
    } = this.props
    return (
      <>
        <SendMailModalForm
          show={this.state.showMailModal}
          disableInput={!new RegExp(format.email.regex).exec(this.state.mail)}
          disabled={false}
          message={getText(
            'payApply.priceSignageCost.emailForSendingCalculation',
          )}
          onClose={() => {
            this.setState({ showMailModal: false })
          }}
          inputValue={this.state.mail}
          onChange={mail => {
            this.setState({ mail })
          }}
          onSubmit={() => {
            this.props.onSendPriceInfoMail(this.state.mail, this.props.limit)
          }}
        />
        <Container>
          <Columns>
            <Column col12>
              <PaymentMethodHeader
                description={selectedPaymentMethod.description}
              >
                <PaymentPerMonth
                  method={selectedPaymentMethod}
                  amount={limit}
                  customerType={customerType}
                  paymentMethodsExist={paymentMethodsExist}
                />
              </PaymentMethodHeader>
            </Column>
            <Column col12>
              <Tabs
                fullWidth
                contentStyling={{ minHeight: '175px' }}
                values={[
                  {
                    value: getText('payApply.paymentMethods.tabs.handle'),
                    active: true,
                    content: (
                      <>
                        <div
                          style={{
                            marginTop: '2rem',
                            padding: '0 1rem 0.5rem 1rem',
                            border: '1px solid lightgrey',
                          }}
                        >
                          <div style={{ display: 'flex' }}>
                            <div style={{ flex: '40%' }}>
                              <CreditLimit
                                selectedPaymentMethod={selectedPaymentMethod}
                                limit={limit}
                                minApplicationLimit={
                                  selectedPaymentMethod.minApplicationLimit
                                }
                                maxApplicationLimit={
                                  selectedPaymentMethod.maxApplicationLimit
                                }
                                disabled={newPageLoading}
                                isValid={validation => this.valid(validation)}
                                onChangeLimit={newLimit => {
                                  if (
                                    newLimit >=
                                      selectedPaymentMethod.minApplicationLimit &&
                                    newLimit <=
                                      selectedPaymentMethod.maxApplicationLimit &&
                                    selectedPaymentMethod.repaymentMonths
                                  ) {
                                    this.props.getCostAlternatives(
                                      newLimit,
                                      selectedPaymentMethod.id,
                                    )
                                  }
                                  onChangeLimit(newLimit)
                                }}
                              />
                              {this.props.selectedPaymentMethod
                                .repaymentMonths && (
                                <CreditPlan
                                  costAlternatives={this.props.costAlternatives}
                                  months={
                                    this.state.creditCost.months ||
                                    this.props.monthlyCost.months
                                  }
                                  monthlyCost={
                                    this.state.creditCost.monthlyCost ||
                                    this.props.monthlyCost.monthlyCost
                                  }
                                />
                              )}
                            </div>
                            <div
                              style={{
                                flex: '60%',
                                padding: '0.5rem 0 0 0',
                              }}
                            >
                              {this.props.selectedPaymentMethod
                                .repaymentMonths && (
                                <CreditInfo
                                  cost={this.props.monthlyCost}
                                  limit={limit}
                                  onSendMail={() => {
                                    this.setState({ showMailModal: true })
                                  }}
                                />
                              )}
                            </div>
                          </div>
                          {this.props.selectedPaymentMethod.repaymentMonths && (
                            <CreditSlider
                              values={this.props.costAlternatives}
                              onChange={v => {
                                this.props.getPaymentPerMonth(
                                  selectedPaymentMethod.id,
                                  limit,
                                  v.months,
                                )
                                this.setState({ creditCost: v })
                                this.props.onChangePeriodOfRepayment(v.months)
                              }}
                            />
                          )}
                        </div>
                        {!debitDisabled && (
                          <div
                            style={{
                              marginTop: '1rem',
                              padding: '1rem 2rem 2rem',
                              border: '1px solid lightgrey',
                            }}
                          >
                            <DebitPayment
                              disabled={
                                newPageLoading ||
                                (selectedPaymentMethod.purchaseAllowed !==
                                  undefined &&
                                  !selectedPaymentMethod.purchaseAllowed)
                              }
                              debitPaymentChecked={debitPaymentChecked}
                              isValid={validation => this.valid(validation)}
                              onDebitPaymentSwitch={checked =>
                                onDebitPaymentSwitch(checked)
                              }
                              onChangeAmount={newAmount =>
                                onChangeAmount(newAmount)
                              }
                              debitReference={debitReference}
                              onChangeDebitReference={ref =>
                                onChangeDebitReference(ref)
                              }
                              minPurchaseLimit={
                                selectedPaymentMethod.minPurchaseLimit
                              }
                              maxPurchaseLimit={limit}
                            />
                          </div>
                        )}
                      </>
                    ),
                  },
                  {
                    value: getText('payApply.paymentMethods.tabs.info'),
                    content: (
                      <div style={{ marginTop: '2rem' }}>
                        <PaymentMethodDescription
                          method={selectedPaymentMethod}
                        />
                      </div>
                    ),
                  },
                  {
                    value: isRevolvingCredit(selectedPaymentMethod.type)
                      ? getText('payApply.paymentMethods.tabs.codesAccount')
                      : getText('payApply.paymentMethods.tabs.codesCard'),
                    content: null,
                    disabled: true,
                  },
                  {
                    value: renderBonusLabel(this.props.bonusChecks),
                    content: <BonusChecks />,
                    disabled: !this.props.hasBonusSupport,
                  },
                ]}
              />
            </Column>
          </Columns>
        </Container>
      </>
    )
  }
}

NewCardOrAccount.propTypes = {
  selectedPaymentMethod: PropTypes.object.isRequired,
  limit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  newPageLoading: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  onChangeLimit: PropTypes.func.isRequired,
  onDebitPaymentSwitch: PropTypes.func.isRequired,
  debitPaymentChecked: PropTypes.bool.isRequired,
  onChangeAmount: PropTypes.func.isRequired,
  debitReference: PropTypes.string,
  onChangeDebitReference: PropTypes.func.isRequired,
  customerType: PropTypes.string.isRequired,
  hasBonusSupport: PropTypes.bool.isRequired,
  bonusChecks: PropTypes.array.isRequired,
  getCostAlternatives: PropTypes.func.isRequired,
  costAlternatives: PropTypes.array.isRequired,
  getPaymentPerMonth: PropTypes.func.isRequired,
  monthlyCost: PropTypes.object.isRequired,
  onChangePeriodOfRepayment: PropTypes.func.isRequired,
  onSendPriceInfoMail: PropTypes.func.isRequired,
  debitDisabled: PropTypes.bool.isRequired,
  paymentMethodsExist: PropTypes.bool,
}

NewCardOrAccount.defaultProps = {
  debitReference: null,
  limit: null,
  paymentMethodsExist: false,
}

export default NewCardOrAccount
